import {
  Input,SimpleChanges,OnChanges,
  Component,
  EventEmitter,
  Output,
  OnInit
} from '@angular/core';
import {SessionTimeVM} from "../../../models/SessionTimeVM.model";

@Component({
  selector: 'rw-time-picker',  // <home></home>
  styles: [require('./time-picker.component.css')],
  template: require('./time-picker.component.html')
})
export class TimePickerComponent implements OnInit,OnChanges {

  @Input() public showEndOfTimeSession = false;
  @Input() public sessionTimes:SessionTimeVM[] = [];
  @Input() public selectedTime:SessionTimeVM;
  @Output()selectedTimeChanged:EventEmitter<SessionTimeVM> = new EventEmitter();

  constructor() {
  }

  public ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;


  }

  onSelectedTimeChanged(e) {
    this.selectedTime = e.value;
    this.selectedTimeChanged.emit(this.selectedTime);
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/time-picker/time-picker.component.ts